<res-base-modal [modalTitle]="modalTitle" [modalAutomationId]="modalAutomationId"
    [verifyRequiredValidator]="verifyRequiredValidator" [primaryButtonLabel]="primaryButtonLabel"
    (primaryButtonActionEmt)="ok()" (closeButtonActionEmt)="closeModal()" [secondaryButtonLabel]="secondaryButtonLabel"
    [isPrimaryBtnEnabled]="isPrimaryButtonEnabled()" [(isBusy)]="isBusy" [modalHelpIndex]="modalHelpIndex"
    [(isBusyMessage)]="isBusyMessage" [modalClass]="modalClass">
    <div class="content">
        <div class="left-section">
            <res-connector-picker [modalAutomationId]="modalAutomationId" [treeHeaderText]="'Folder'" (getConnector)="getConnector($event)" (getPath)="getPath($event)" [filterConnectors]="true">
            </res-connector-picker>
        </div>
        <div class="right-section">
            <res-new-data-set-load-file-menu [isLoadFile]="true" [modalAutomationId]="modalAutomationId">
            </res-new-data-set-load-file-menu>
        </div>
    </div>
</res-base-modal>